export default __webpack_public_path__ + "static/media/F0007.34e82578.png";